<template>
  <div>
    <v-card>
      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="6">
              <v-simple-table>
                <thead>
                <tr>
                  <th class="text-left">
                    Id
                  </th>
                  <th class="text-left">
                    Created at
                  </th>
                  <th class="text-left">
                    Type
                  </th>
                  <th class="text-left">
                    Client
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="patientCase in patient.patientCases"
                    :style="{'cursor': 'pointer'}"
                    :key="patientCase.id"
                    @click="handleCaseClick(patientCase)"
                >
                  <td>{{ patientCase.caseSystemId }}</td>
                  <td>{{ patientCase.createdAt | DateWithMinutes }}</td>
                  <td>{{ getCaseTypeTitle(patientCase.caseType) }}</td>
                  <td>{{ getClientTitle(patientCase.clientId) }}</td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card class="mt-5">
      <v-card-title>Add new case</v-card-title>
      <v-card-text class="text--primary" style="display: flex;">
        <div style="max-width: 250px; width: 250px;">
          <v-select
              class="form-item ml-1"
              v-model="caseType"
              :items="availableCaseTypes"
              item-text="title"
              item-value="value"
              outlined
              dense
              label="Case type"
          ></v-select>
        </div>
        <v-btn class="ml-3" color="success" :disabled="!caseType" @click="handleCreateCaseButtonClick">Create</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import {mapState, mapGetters, mapActions} from 'vuex'
import DateWithMinutes from 'js-core/components/Filters/DateWithMinutes'

export default {
  name: 'PatientCases',
  props: {
    patient: Object,
  },
  data() {
    return {
      caseType: null,
    }
  },
  computed: {
    ...mapState('cases', {
      availableCaseTypes: 'availableCaseTypes'
    }),
    ...mapGetters('clients', {
      clientsById: 'clientsById'
    }),
    ...mapGetters('cases', {
      availableCaseTypesByValue: 'availableCaseTypesByValue'
    })
  },
  filters: {
    DateWithMinutes
  },
  methods: {
    ...mapActions('pgtCases', {
      setPatientContext: 'setPatientContext'
    }),
    getClientTitle(clientId) {
      return _.get(this.clientsById, [clientId, 'title'], '-')
    },
    getCaseTypeTitle(caseType) {
      return _.get(this.availableCaseTypesByValue, [caseType, 'title'], caseType)
    },
    handleCaseClick(patientCase) {
      switch (patientCase.caseType) {
        case 'pgt':
          this.$router.push(`/cases/pgt/update/${patientCase.caseSystemId}`)
          break
        default:
          this.$router.push(`/cases/update/${patientCase.caseSystemId}`)
      }
    },
    async handleCreateCaseButtonClick() {
      switch (this.caseType) {
        case "pgt": {
          await this.setPatientContext(this.patient)
          this.$router.push('/cases/pgt/create')
          break;
        }
        default:
      }
      //this.$router.push()
    }
  }
}
</script>

<style scoped>

</style>